import React from 'react'
import { CloseIcon } from '@chakra-ui/icons'
import { ButtonProps, Button } from '@chakra-ui/react'

export default function ClearButton(props: Readonly<ButtonProps>) {
    return (
        <Button size="xs" mt={1} variant="ghost" {...props}>
            <CloseIcon boxSize={2} mr={1} /> Clear
        </Button>
    )
}
